import { formatDistanceToNow, intervalToDuration } from 'date-fns'

/**
 * Formats a date string to a human-readable relative time
 * @param {string} dateString - ISO 8601 date string
 * @returns {string} Formatted relative time (e.g., "3 minutes ago", "about 2 hours ago")
 */
export const formatRelativeTime = (dateString) => {
  return formatDistanceToNow(new Date(dateString), { addSuffix: true })
}

/**
 * Calculates the duration between two dates and formats it
 * @param {string|null} startDate - Start date (ISO 8601 string)
 * @param {string|null} endDate - End date (ISO 8601 string)
 * @returns {string} Formatted duration (e.g., "2m 30s", "1h 5m", "45s") or "-" if dates are invalid
 */
export const formatDuration = (startDate, endDate) => {
  if (!startDate || !endDate) return '-'
  
  const start = new Date(startDate)
  const end = new Date(endDate)
  
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return '-'
  if (end < start) return '-'
  
  const duration = intervalToDuration({ start, end })
  
  // Custom compact format
  const parts = []
  if (duration.hours) parts.push(`${duration.hours}h`)
  if (duration.minutes) parts.push(`${duration.minutes}m`)
  if (duration.seconds && !duration.hours) parts.push(`${duration.seconds}s`) // Skip seconds if we have hours
  
  return parts.length > 0 ? parts.join(' ') : '0s'
}
